import React from 'react';

import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import Text from '@components/Text';
import Tag from '@components/Tag';
import BulletList from '@components/BulletList';
import Bullet from '@components/Bullet';

const TEXTSTYLE = {
  'default': {
    text: { textAlign: 'left', fontWeight: 'normal' },
    value: { textAlign: 'right', fontWeight: 'bold' },
  },
  'alternate-color': {
    text: { textAlign: 'left', fontWeight: 'normal' },
    value: { textAlign: 'right', fontWeight: 'normal' },
  },
  'dash': {
    text: { textAlign: 'left', fontWeight: '600' },
    value: { textAlign: 'left', fontWeight: 'normal' },
  },
  'table': {
    text: { textAlign: 'left', fontWeight: 'bold' },
    value: { textAlign: 'right', fontWeight: 'bold' },
  }
}



interface StyledProps {
  theme?: ITheme;
  variant: 'default' | 'alternate-color' | 'dash' | 'table';
  margin?: string | number;
  marginItems?: string | number;
}

interface Source {
  text: string | undefined;
  value: string | number | undefined;
  fontWeight?: number | string;
  type?: string;
  promotions?: string[];
  children?: string[];
}
export interface ListingProps {
  variant: 'default' | 'alternate-color' | 'dash'| 'table';
  sources: Source[];
  theme?: ITheme;
  margin: string | number;
  marginItems: string | number;
}


const Container = styled.div<StyledProps>`
  margin: ${props => props.margin ? (typeof props.margin === 'number' ? `${props.margin}px` : props.margin) : '0'};
`
const Row = styled.div<StyledProps>`  
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: ${props => props.variant === 'dash' ? '15px' : '10px'} ${props => props.variant === 'default' ? '0' : props.variant === 'table' ? 0 : '20px'};
  box-sizing: border-box;
  justify-content: space-between;
  border-bottom: ${props => props.variant === 'dash' ? `1px solid ${props.theme?.colors.grey[700]}` : 'unser'};
  margin: ${props => typeof props.marginItems === 'number' ? `${props.marginItems || 0}px` : props.marginItems || 0};
  &:nth-child(odd) {
    background-color: ${props => props.variant === 'alternate-color' ? props.theme?.colors.grey[600] : 'unset'};
  }
  &:nth-child(even) {
    background-color: ${props => props.variant === 'alternate-color' ? props.theme?.colors.white + '' : 'unset'};
  }
  &:last-child {
    border-bottom: ${props => props.variant === 'dash' ? `none` : 'unser'};
  }
`
const Col = styled.div<StyledProps>`
  width: ${props => props.variant === 'dash' ? '50%' : 'auto'};
  margin: ${props => props.margin || 0};
`

const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  .firstPromo {
    margin-bottom: 5px;
   
  }
  @media screen and (min-width: 768px) {
    .firstPromo {
      margin-right: 5px;
      margin-bottom: 0;
    }
  }
`;

function Listing({ sources, variant, margin, marginItems }: ListingProps) {
  const theme = useTheme();
  const styleText = TEXTSTYLE[variant];
  return <Container theme={theme} variant={variant} margin={margin}>
    {sources.map((item: Source, i: number) => {
      return (<Row key={i} theme={theme} variant={variant} marginItems={marginItems}>
        <Col variant={variant} margin="0 20px 0 0">
          {item && item.type && item.type === 'promotion' ?
            <div>
              <Text margin="0 0 8px" align={styleText.text.textAlign} fontWeight={styleText.text.fontWeight}>{item.text}</Text>
              <FlexBox>
                {item.promotions?.map((promo, index) => <div key={`${index}`}><Tag className={item.promotions?.length === 2 && index === 0 ? 'firstPromo' : ''} variant="promo">{promo}</Tag></div>)}
              </FlexBox>
            </div> :
            <Text align={styleText.text.textAlign} fontWeight={styleText.text.fontWeight} dangerouslySetInnerHTML={{__html: item?.text}}/> 
          }
          {
            item && item.children && item.children.length > 0 && (
              <BulletList margin="10px 0 0">
                {item.children.map((o, i: number) => (<Bullet key={`${i}`}>{o}</Bullet>))}
              </BulletList>
            )
          }
        </Col>
        <Col variant={variant} margin="0">
          {Array.isArray(item.value) ?
            (<React.Fragment>
              {item.value.map((o, index: number) => (
                <Text key={`${index}`} align={styleText.value.textAlign} fontWeight={styleText.value.fontWeight}> {o} </Text>
              ))}
            </React.Fragment>) :
            (<Text align={styleText.value.textAlign} fontWeight={item.fontWeight ? item.fontWeight : styleText.value.fontWeight}> {item?.value} </Text>)
          }
        </Col>
      </Row>)
    })}
  </Container>;
};



Listing.defaultProps = {
  variant: 'default',
  sources: [],
  margin: '0 0 30px',
  marginItems: 0,

}

export default Listing;
